module.exports = new __parcel__URL__("machine_info_button.8af12c1a.png").toString();